import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { LoginData } from './../../common/interfaces/user-login.interface';
import { LOGINS } from "@env/environment";
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import Utils from '@utils/utils';
import { ToolsService } from '@services/varios/tools.service';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { AUTH_ROUTE } from 'src/app/common/constants/routes.constants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.scss',
    '../../../assets/libs/login/css/bootstrap.min.css',
    '../../../assets/libs/login/css/layoutLogin_v2.css',
    '../../../assets/libs/login/css/cu.min.css'
  ]
})

export class LoginComponent implements OnInit {

  usuarioLocalForm: FormGroup = { } as FormGroup;
  UsuarioGesdepForm: FormGroup = { } as FormGroup;

  public ClaveUnica: boolean = false;
  public JunjiAD: boolean = false;
  public CorreoMicrosoft: boolean = false;
  public CorreoGoogle: boolean = false;
  public UsuarioLocal: boolean = false;
  public UsuarioGesdep: boolean = false;

  public codeState = Utils.generateStringCode();
  public hashState = Utils.generateHashState(this.codeState);
  public id: any = '';
  public mostrarBoton: boolean = true;

  isFormUCExpanded: boolean = this.route.snapshot.paramMap.get('id') == '2';
  isFormOUExpanded: boolean = this.route.snapshot.paramMap.get('id') == '1';

  constructor(private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly formBuilder: FormBuilder, 
    private readonly toolsService: ToolsService,
    private readonly spinnerService: SpinnerService
  ) { }

  toggleFormUC() { //local
    this.isFormUCExpanded = !this.isFormUCExpanded;
  }

  toggleFormOU() { // Gesdep
    this.isFormOUExpanded = !this.isFormOUExpanded;
  }

  async ngOnInit() {

    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id != '') {
      this.mostrarBoton = false;
    }
    
    if(LOGINS.filter(x=>x.tipo.includes('LOG_UsuarioGesdep'))[0].value != '') {
      this.UsuarioGesdep = true;
    }
    if(LOGINS.filter(x=>x.tipo.includes('LOG_UsuarioLocal'))[0].value != '') {
      this.UsuarioLocal = true;
    }

    this.usuarioLocalForm = this.formBuilder.group({
      usuario: new FormControl(null, Validators.compose([Validators.required, Validators.maxLength(100)])),
      clave: new FormControl(null, Validators.compose([Validators.required, Validators.maxLength(100)])),
    });

    this.UsuarioGesdepForm = this.formBuilder.group({
      run: new FormControl(null, Validators.compose([Validators.required, Validators.maxLength(100)])),
      clave: new FormControl(null, Validators.compose([Validators.required, Validators.maxLength(100)])),
    });

  }

  loginWithClaveUnica() {
    window.location.href = Utils.getAuthorizerLoginUrlProvider('claveunica', this.hashState);
  }

  loginWithJunjiAD() {
    window.location.href = Utils.getAuthorizerLoginUrlProvider('Microsoft', this.hashState);
  }

  loginWithMicrosoft() {
    window.location.href = Utils.getAuthorizerLoginUrlProvider('Microsoft', this.hashState);
  }

  loginWithGoogle() {
    window.location.href = Utils.getAuthorizerLoginUrlProvider('Google', this.hashState);
  }

  async loginUsuarioLocal() {

    let spinnerRef = this.spinnerService.start();

    let usuario = this.usuarioLocalForm.controls["usuario"].getRawValue();
    let clave = this.usuarioLocalForm.controls["clave"].getRawValue();

    const usr: LoginData = {
      password: clave,
      rutUsuario: usuario,
    };

    let respuesta = await this.authService.loginWithLocal(usr);

    this.spinnerService.stop(spinnerRef);

    if(respuesta != null) {
      if(respuesta.usuario != null) {
        if (respuesta.usuario.estadoSistema == 'INACTIVO' && !this.toolsService.userInRol(['ADMINISTRADOR'])) {
          await this.toolsService.errorMensaje(respuesta.usuario.mensajeSistema);
          this.router.navigate([AUTH_ROUTE]);
        } else {
          localStorage.setItem('LOGINGSSO','0');
          this.router.navigate([this.toolsService.itemMenuDefault()]);  
        }  
      } else if(respuesta.resp == null) {
          await this.toolsService.errorMensaje("Usuario o Password inválido");
        } else {
          await this.toolsService.errorMensaje(respuesta.resp);
        }
    } else {
      await this.toolsService.errorMensaje("Usuario o Password inválido");;
    }
  }

  async loginUsuarioGesdep() {

    let spinnerRef = this.spinnerService.start();

    let run = this.UsuarioGesdepForm.controls["run"].getRawValue();
    let clave = this.UsuarioGesdepForm.controls["clave"].getRawValue();

    const usr: LoginData = {
      password: clave,
      rutUsuario: run,
    };

    let respuesta = await this.authService.loginWithGesdep(usr);

    this.spinnerService.stop(spinnerRef);

    if(respuesta != null) {
      if(respuesta.usuario != null) {
        if (respuesta.usuario.estadoSistema == 'INACTIVO' && !this.toolsService.userInRol(['ADMINISTRADOR'])) {
          await this.toolsService.errorMensaje(respuesta.usuario.mensajeSistema);
          this.router.navigate([AUTH_ROUTE]);
        } else {
          localStorage.setItem('LOGINGSSO','0');
          this.router.navigate([this.toolsService.itemMenuDefault()]);  
        }  
      } else if(respuesta.resp == null) {
          await this.toolsService.errorMensaje("Usuario o Password inválido");
        } else {
          await this.toolsService.errorMensaje(respuesta.resp);
        }
    } else {
      await this.toolsService.errorMensaje("Usuario o Password inválido");
    }
  }
}